import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { UserApplicationPort } from 'user/port/user-application.port';
import { IUser } from 'user/user';

@Pipe({
	name: 'userDate',
})
export class UserDatePipe implements PipeTransform {
	constructor(private _userApplicationPort: UserApplicationPort) {}

	transform(
		value: Date | number,
		format: string,
		user?: Observable<IUser>
	): Observable<string> {
		if (!value) {
			return of('-');
		}

		return (user || this._userApplicationPort.observeSessionUser()).pipe(
			map((user) => (user ? user.timeZone : null)),
			distinctUntilChanged(),
			map((timeZone) =>
				timeZone
					? moment.tz(value instanceof Date ? value.getTime() : value, timeZone)
					: moment(value instanceof Date ? value.getTime() : value)
			),
			map((m) => m.format(format))
		);
	}
}
